import { mapState } from 'vuex';

import { PasswordWithStrength } from 'ipro-ui-kit-vuejs/src/components';

import { AuthService } from '@/auth';
import { InvitationService } from '@/core/invitations';
import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  components: {
    PasswordWithStrength,
  },
  mixins: [
    AuthRoutes,
  ],
  data() {
    return {
      inputs: {
        first_name: {
          properties: {
            label: 'First name',
            'label-icon': 'far fa-user',
            name: 'first_name',
            required: true,
            'tooltip-text': 'We respect your privacy and are committed to protecting your private information. Your name is used to personalise communication.',
            'validation-rules': 'required',
          },
          value: '',
        },
        last_name: {
          properties: {
            label: 'Last name',
            'label-icon': 'far fa-user',
            name: 'last_name',
            required: true,
            'tooltip-text': 'We respect your privacy and are committed to protecting your private information. Your name is used to personalise communication.',
            'validation-rules': 'required',
          },
          value: '',
        },
        email: {
          properties: {
            label: 'Email address',
            'label-icon': 'far fa-envelope',
            name: 'email',
            required: true,
            'tooltip-text': 'We respect your privacy and are committed to protecting your private information. We use your email address to secure your account and contact you about required action.',
            type: 'email',
            'validation-rules': 'required|email',
          },
          value: this.$route.query.email || '',
        },
        password: {
          properties: {
            label: 'Password',
            name: 'password',
            required: true,
          },
          value: '',
        },
      },
      requestInProgress: false,
      addingInvitationCode: false,
      invitations: [],
      newInvitationCode: this.$route.query.invitation_code || '',
    };
  },
  computed: {
    ...mapState({
      privacyPolicyLink: state => state.config.privacyPolicyLink,
      termsAndConditionsLink: state => state.config.termsAndConditionsLink,
    }),
    hasInvitationCode() {
      return !!this.invitations.length || this.addingInvitationCode;
    },
  },
  mounted() {
    if (this.newInvitationCode) {
      this.saveInvitationCode();
    }
  },
  methods: {
    async signup() {
      this.requestInProgress = true;

      try {
        const credentials = {
          user_type: 'worker',
          first_name: this.inputs.first_name.value,
          last_name: this.inputs.last_name.value,
          email: this.inputs.email.value,
          password: this.inputs.password.value,
        };
        await AuthService.register(credentials);

        this.$router.push({
          name: 'redirect',
          query: this.$route.query,
        });
      } catch (error) {
        // Do nothing
      }

      this.requestInProgress = false;
    },
    toggleNewInvitationCodeInput(showInvitationCodeInput) {
      this.addingInvitationCode = !!showInvitationCodeInput;
    },
    updateUrl(invitations) {
      const query = _.cloneDeep(this.$route.query);
      const invitationCodes = invitations.map(i => i.invitationCode);
      if (!invitationCodes.length) {
        if (query.redirect_to) {
          query.redirect_to = query.redirect_to.split('?')[0];
        }

        delete query.invitation_code;
        delete query.sent_invitation_uuid;
      } else {
        query.invitation_code = invitationCodes[0];
        const queryParamString = `invitation_code=${query.invitation_code}`;
        if (query.redirect_to && !query.redirect_to.match(queryParamString)) {
          query.redirect_to = `${query.redirect_to}?${queryParamString}`;
        }
      }
      this.$router.replace({ query });
    },
    async saveInvitationCode() {
      try {
        const response = await InvitationService.getCode(this.newInvitationCode);
        const validInvitationCode = response.code;
        this.invitations.push({
          invitationCode: validInvitationCode,
        });
      } catch (error) {
        // Do nothing
      } finally {
        this.updateUrl(this.invitations);
      }

      this.resetNewInvitationCodeInput();
    },
    resetNewInvitationCodeInput() {
      this.toggleNewInvitationCodeInput(false);
      this.newInvitationCode = '';
    },
    removeInvitation(invitationToRemove) {
      this.invitations = this.invitations.filter(inv => inv !== invitationToRemove);
      this.updateUrl(this.invitations);
    },
  },
};
